import React, { useCallback } from 'react';
import c from 'classnames';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton/ExclusiveButton';
import { Trans, useTranslation } from 'react-i18next';
import { getHasOwnOffer, getIsAdoptableFixedPriceType, getIsAdoptableOfferType, getIsOnSale, getPrice } from '../../../utils/adoptables';
import { BiData } from '@wix/da-bi/pkg/events';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../../../publicSession/selectors';
import { useRestrictToLoggedInAndVerified } from '../../../utils/hooks/useRestrictToLoggedInAndVerified';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { Url } from '@wix/da-url';
import { pushAdoptsBuyerModal } from '../../../Modals/redux/actionCreators';
import { isDeviationAuthor } from '../../../DeviationViews/_helpers';
import s from './AdoptableBuyerButtons.scss';
// The same as ActionBar/buttons/AdoptableBuyer but outside the actionbar
const AdoptableBuyerButtons = ({ deviation, className })=>{
    var _deviation_extended_adoptable, _deviation_extended;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isOfferType = getIsAdoptableOfferType(deviation);
    const isFixedPriceType = getIsAdoptableFixedPriceType(deviation);
    const price = getPrice(deviation);
    const onSale = getIsOnSale(deviation);
    const user = useSelector(getCurrentUser);
    const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();
    const hasOffer = getHasOwnOffer(deviation);
    const gotoCheckout = useCallback(()=>{
        var _deviation_extended_adoptable_fixedPrice, _deviation_extended_adoptable, _deviation_extended;
        var _deviation_extended_adoptable_fixedPrice_subproductId;
        window.location.assign(Url.checkoutLink((_deviation_extended_adoptable_fixedPrice_subproductId = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : (_deviation_extended_adoptable_fixedPrice = _deviation_extended_adoptable.fixedPrice) === null || _deviation_extended_adoptable_fixedPrice === void 0 ? void 0 : _deviation_extended_adoptable_fixedPrice.subproductId) !== null && _deviation_extended_adoptable_fixedPrice_subproductId !== void 0 ? _deviation_extended_adoptable_fixedPrice_subproductId : 0));
    }, [
        deviation
    ]);
    const restrictedGoToCheckout = restrictToLoggedInAndVerified(ReferralType.SIDEBAR_PROMOTION, undefined, gotoCheckout);
    const openManageOfferModal = useCallback(()=>{
        dispatch(pushAdoptsBuyerModal(deviation, 'offer'));
    }, [
        deviation,
        dispatch
    ]);
    const restrictedOpenManageOfferModal = restrictToLoggedInAndVerified(ReferralType.ACTION_BAR, undefined, openManageOfferModal);
    if (!onSale || ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.isOwner) || isDeviationAuthor(deviation, user)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, isFixedPriceType && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        className: s['smaller-button'],
        priority: "secondary",
        biData: BiData({
            evid: 750,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            purchase_price: parseFloat(price),
            sectionname: 'side-rail',
            is_gift: 0
        }),
        onClick: restrictedGoToCheckout
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'actionbar.adoptables.adoptForPrice'
    }, "Adopt for $", {
        price
    })), isOfferType && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        className: s['smaller-button'],
        priority: "primary",
        biData: BiData({
            evid: 751,
            itemid: deviation.deviationId,
            typeid: deviation.typeId,
            sectionname: 'side-rail'
        }),
        onClick: restrictedOpenManageOfferModal
    }, hasOffer ? t('actionbar.adoptables.manageOffer') : t('actionbar.adoptables.makeOffer')));
};
AdoptableBuyerButtons.displayName = 'AdoptableBuyerButtons';
export default AdoptableBuyerButtons;

//# sourceMappingURL=AdoptableBuyerButtons.js.map